var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomWCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 50,
    viewBox: "0 0 149 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.8494 10.0482C60.0208 9.98963 45.4009 6.82388 32.0963 0.790527L0.295166 30.415C22.607 43.2153 48.3649 50.0001 74.6484 50.0001C100.932 50.0001 126.69 43.2153 149.002 30.415L117.201 1.11454C103.993 6.99054 89.5162 10.0443 74.8494 10.0482Z",
    fill: "#FFBC78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomWCurve);
export default __webpack_public_path__ + "static/media/bottom-w-curve.ba67831392d820c6b1617d98e9328cdc.svg";
export { ForwardRef as ReactComponent };